export const SYSTEM_MESSAGE_IDS = {
  INCORRECT_USERNAME_PASSWORD: 'PP1',
  BLANK_USERNAME: 'PP2',
  BLANK_PASSWORD: 'PP3',
  INVALID_OTP: 'PP4',
  BLANK_OTP: 'PP5',
  EXPIRED_OTP: 'PP6',
  INCORRECT_CURRENT_PASSWORD: 'PP7',
  PASSWORD_IS_TOO_SHORT: 'PP8',
  PASSWORD_LONGER_THAN_128_CHAR: 'PP9',
  PASSWORD_NO_LOWERCASE: 'PP10',
  PASSWORD_NO_UPPERCASE: 'PP11',
  PASSWORD_NO_NUMBER: 'PP12',
  NEW_PASSWORD_SAME_AS_OLD: 'PP13',
  CONFIRMED_PASSWORD_DIFFERENT_FROM_NEW: 'PP14',
  FILE_DOWNLOAD_COMPLETE: 'PP15',
  NETWORK_INTERRUPTION_WHILE_DOWNLOADING_FILE: 'PP16',
  NEW_PASSWORD_NO_SPECIAL_CHAR: 'PP17',
  INSUFFICIENT_DISK_SPACE: 'PP18',
  GENERAL_ERROR_MESSAGE: 'PP19',
  DELETE_RECORD: 'PP20',
  VOID_CHECK: 'PP21',
  VERIFY_CHECK: 'PP26',
  ANYTIME_DATA_OVERWRITTEN: 'PP22',
  ANYTIME_CHANGES_SAVED: 'PP23',
  SAVE_FAVORITE_PAGE: 'PP24',
  UNSAVE_FAVORITE_PAGE: 'PP25',
  PLEASE_RESEND_OTP_LATER: 'PP27',
  UPDATE_PASSWORD_SUCCESS: 'PP28',
  SEND_EMAIL_FORGOT_PASSWORD_SUCCESS: 'PP29',
  BLANK_CLIENT_NAME: 'PP32',
  BLANK_CLIENT_NUMBER: 'PP33',
  INVALID_EXCEPTION_REMINDER_EMAIL_TIME: 'PP36',
  CLIENT_NAME_CREATED_SUCCESSFULLY: 'PP39',
  CLIENT_NAME_UPDATED_SUCCESSFULLY: 'PP40',
  CLIENT_NAME_ARICHIVE: 'PP41',
  CLIENT_NAME_ACTIVE: 'PP42',
  CLIENT_IS_ALREADY_ACTIVE: 'PP84',
  FIELD_IS_REQUIRED: 'PPA01',
  ACCOUNT_ACTIVE: 'PP70',
  ACCOUNT_ACTIVE_SUCCESSFULLY: 'PP83',
  ACCOUNT_ARCHIVE_SUCCESSFULLY: 'PP82',
  ACCOUNT_CREATED_SUCCESSFULLY: 'PP67',
  ACCOUNT_UPDATED_SUCCESSFULLY: 'PP75',
  CLIENT_ARCHIVED: 'PP88',
  ACCOUNT_NOT_EXIST: 'PPI11',
  EXCEED_LIMIT_FILE_SIZE: 'PPC01',
  UPLOAD_FAIL_UNEXPECTED_ERROR: 'PPC03',
  FILE_MAPPING_CREATED_SUCCESSFULLY: 'PPC04',
  FORMAT_NAME_UNIQUE: 'PPC05',
  SELECT_FORMAT_TYPE_FIRST: 'PPC06',
  FILE_MAPPING_UPDATED_SUCCESSFULLY: 'PPC07',
  FILE_MAPPING_DELETE_SUCCESSFULLY: 'PPC08',
  ROLE_NAME_REQUIRED: 'PP76',
  AL_LEAST_ONE_NAVIGATION_OPTION: 'PP89',
  INVALID_VALUE_IN_NUMBER_FIELD: 'PPF15',
  CREATE_ROLE_NAME_SUCCESS: 'PP79',
  UPDATE_ROLE_NAME_SUCCESS: 'PP81',
  INVALID_EMAIL: 'PPB01',
  BANK_USER_CREATED_SUCCESSFULLY: 'PPB03',
  CLIENT_USER_CREATED_SUCCESSFULLY: 'PPB03',
  CLIENT_USER_UPDATED_SUCCESSFULLY: 'PPB06',
  AMOUNT_TO_MUST_EQUAL_OR_GREATER_THAN_AMOUNT_FROM: 'PPL02',
  ACH_EXCEPTION_RULE_CREATED_SUCCESSFULLY: 'PPL03',
  ACH_EXCEPTION_RULE_UPDATED_SUCCESSFULLY: 'PPL04',
  ACH_EXCEPTION_RULE_CREATED_FROM_UPLOAD_SUCCESSFULLY: 'PPL23',
  ALREADY_USERNAME: 'PPB02',
  ALREADY_EMAIL: 'PPB05',
  INVALID_PHONE_NUMBER: 'PPA05',
  INVALID_FILE_FORMAT: 'PPC02',
  INVALID_SUBMIT_CHECK_FILE_SIZE: 'PP47',
  INVALID_CHECK_FILE_FORMAT: 'PPF07',
  FAILED_TO_SUBMIT_CHECK_FILE: 'PP64',
  ALREADY_EXIST: 'PPD04',
  BANK_USER_UPDATED_SUCCESSFULLY: 'PPB06',
  USER_ACTIVE: 'PPB04',
  PAGE_NAME_PUBLISHED_SUCCESSFULLY: 'PPD02',
  PAGE_NAME_SCHEDULED_SUCCESSFULLY: 'PPD03',
  CHECK_FILE_PROCESSING: 'PPF04',
  CHECK_SUBMITTED_SUCCESSFULLY: 'PPF05',
  CHECK_FILE_SUBMIT_TIMEOUT: 'PPF06',
  RESTORE_VERSION_SUCCESSFULLY: 'PPD05',
  CHECK_SUBMITTED_SUCCESSFULLY_BUT_SOME_DUPLICATED: 'PPF08',
  CHECK_SUBMITTED_SUCCESSFULLY_BUT_ALL_DUPLICATED: 'PPF09',
  INVALID_FILE_MAPPING_SETUP: 'PPF17',
  FILE_MAPPING_MISSING_COLUMNS: 'PPF20',
  INVALID_CHECK_FILE_MAPPING: 'PPF21',
  SAVE_DRAFT_SUCCESSFULLY: 'PPD01',
  SAVE_NEW_SUCCESSFULLY: 'PPA02',
  OBJECT_DUPLICATED: 'PPA06',
  INVALID_PARAMETER: 'PPM01',
  CAN_NOT_DELETE_PAYEE_MATCH_PARAMETER: 'PPM02',
  UPDATE_SUCCESSFULLY: 'PPA03',
  INVALID_AMOUNT_FORMAT: 'PPA05',
  DELETE_ACH_SUCCESSFULLY: 'PPL05',
  CHECK_NUMBER_VOID_SUCCESSFULLY: 'PPF19',
  AT_LEAST_ONE_ACCOUNT_PER_CLIENT: 'PPL25',
  DECISION_CHECK_MADE_SUCCESSFULLY: 'PPN02',
  DECISION_ACH_MADE_SUCCESSFULLY: 'PPN01',
  POSITIVE_NUMBER: 'PPA09',
  FILE_UPLOAD_TIMEOUT: 'PPL08',
  UPLOADED_DATA_DELETED_SUCCESSFULLY: 'PPI01',
  ACCOUNT_UPLOAD_CREATED_FROM_UPLOAD_SUCCESSFULLY: 'PPP24',
  ACCOUNT_UPLOAD_UPDATED_FROM_UPLOAD_SUCCESSFULLY: 'PPP25',
  ACCOUNT_IN_SYSTEM: 'PPE04',
  ACCOUNT_BELONGS_TO_ANOTHER_CLIENT: 'PPE03',
  DUPLICATE_ACCOUNT: 'PPI21',
  COLUMN_IS_REQUIRED: 'PPP05',
  NULL_OR_EMPTY_VALUE: 'PPI13',
  CLIENT_NOT_EXIST: 'PPI9',
  NUMBER_MUST_FROM_ONE: 'PPC11',
  NUMBER_FROM_MUST_LESS_THAN_NUMBER_TO: 'PPC12',
  NUMBER_TO_MUST_LESS_THAN_MAX_COLUMN: 'PPC13',
  CHECK_NUMBER_MAX_LENGTH_ERROR: 'PPF32',
  AMOUNT_FORMAT_ERROR: 'PPF33',
  ISSUED_PAYEE_MAX_LENGTH_ERROR: 'PPF34',
  INVALID_FIELD_VALIDATION: 'PPA01',
  ISSUED_CHECK_FILE_SUCCESSFULLY_BUT_CHECKS_INCORRECT: 'PPF11',
  ISSUED_CHECK_UPDATED_SUCCESSFULLY: 'PPF47',
  ISSUED_CHECK_DELETED_SUCCESSFULLY: 'PPF49',
  PENDING_USER_EMAIL_INTERACTION: 'PENDING',
  MANUAL_EXCEPTION_NOTIFICATIONS_SENT: 'PP92'
}
